import { render, staticRenderFns } from "./smsMessage.vue?vue&type=template&id=60cba8fd&scoped=true&"
import script from "./smsMessage.vue?vue&type=script&lang=js&"
export * from "./smsMessage.vue?vue&type=script&lang=js&"
import style0 from "./smsMessage.vue?vue&type=style&index=0&id=60cba8fd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60cba8fd",
  null
  
)

export default component.exports